export { default } from './FormatField';



// WEBPACK FOOTER //
// ./app/components/shared/Facets/FormatField/index.js